import { createAsyncThunk } from "@reduxjs/toolkit";
import { del, patch, post } from "helpers/api_helper";
import {
  ADD_CLOSURE,
  DELETE_CLOSURE,
  GET_ALL_CLOSURES,
  GET_CLOSURE_DETAILS,
  UPDATE_CLOSURE,
  UPDATE_CLOSURE_STATUS,
} from "helpers/url_helper";

export const getAllClosures = createAsyncThunk(
  GET_ALL_CLOSURES,
  async (payload) => {
    const response = await post(GET_ALL_CLOSURES, payload);
    return response;
  }
);

export const addClosure = createAsyncThunk(ADD_CLOSURE, async (payload) => {
  const response = await post(ADD_CLOSURE, payload);
  return response;
});

export const updateClosure = createAsyncThunk(
  UPDATE_CLOSURE,
  async (payload) => {
    const response = await patch(UPDATE_CLOSURE, payload);
    return response;
  }
);

export const getClosureDetails = createAsyncThunk(
  GET_CLOSURE_DETAILS,
  async (payload) => {
    const response = await post(GET_CLOSURE_DETAILS, payload);
    return response;
  }
);

export const updateClosureStatus = createAsyncThunk(
  UPDATE_CLOSURE_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_CLOSURE_STATUS, payload);
    return response;
  }
);

export const deleteClosure = createAsyncThunk(
  DELETE_CLOSURE,
  async (payload) => {
    const response = await del(DELETE_CLOSURE, payload);
    return response;
  }
);
